import type { CSSProperties } from 'react';

export const TEAM_ROSTER_GRID_GAP_PX = 12;
export const TEAM_ROSTER_GRID_PAD_X_PX = 12;

export const TEAM_ROSTER_TRACK_MINS_PX = {
  products: 180,
  capacity: 48,
  historical: 52,
  exclForecast: 64,
  startDate: 110,
  endDate: 110,
  role: 132,
  name: 148,
  email: 140,
  jira: 128,
  hours: 72,
  actions: 88,
} as const;

export const TEAM_ROSTER_TRACK_ORDER: ReadonlyArray<keyof typeof TEAM_ROSTER_TRACK_MINS_PX> = [
  'products',
  'capacity',
  'historical',
  'exclForecast',
  'startDate',
  'endDate',
  'role',
  'name',
  'email',
  'jira',
  'hours',
  'actions',
];

export function teamRosterGridMinWidthPx(
  mins: Record<string, number> = TEAM_ROSTER_TRACK_MINS_PX,
  order: readonly string[] = TEAM_ROSTER_TRACK_ORDER
): number {
  if (order.length === 0) return TEAM_ROSTER_GRID_PAD_X_PX * 2;
  const trackSum = order.reduce((sum, key) => sum + (mins[key] ?? 0), 0);
  return trackSum + TEAM_ROSTER_GRID_GAP_PX * (order.length - 1) + TEAM_ROSTER_GRID_PAD_X_PX * 2;
}

export const TEAM_ROSTER_GRID_MIN_WIDTH = teamRosterGridMinWidthPx();

const t = TEAM_ROSTER_TRACK_MINS_PX;

export const TEAM_ROSTER_GRID_TEMPLATE_COLUMNS = [
  `minmax(${t.products}px, 2.2fr)`,
  `${t.capacity}px`,
  `${t.historical}px`,
  `${t.exclForecast}px`,
  `minmax(${t.startDate}px, 0.9fr)`,
  `minmax(${t.endDate}px, 0.9fr)`,
  `minmax(${t.role}px, 1fr)`,
  `minmax(${t.name}px, 1.4fr)`,
  `minmax(${t.email}px, 1.2fr)`,
  `minmax(${t.jira}px, 1fr)`,
  `${t.hours}px`,
  `${t.actions}px`,
].join(' ');

export const TEAM_ROSTER_HEADER_TEXT_CELL: CSSProperties = {
  padding: '0.5rem 0.35rem',
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
};

/** Fixed slot height for react-window (row card + gap below). */
export const TEAM_ROSTER_VIRTUAL_ROW_SIZE = 152;

/** Max viewport height for the virtualized roster body scroll region. */
export const TEAM_ROSTER_VIRTUAL_LIST_MAX_HEIGHT = 560;

/** Below this row count on a page, render plain DOM rows (avoid list overhead). */
export const TEAM_ROSTER_VIRTUALIZE_THRESHOLD = 14;
